import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/animation.jpg";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/images/github.svg';

export const Footer = () => {
  return (
    <>
      <style>{`
        .footer {
          padding: 40px 0;
          background-color: #1A1A1A; /* Slightly lighter dark for better contrast */
          color: #ddd;
          text-align: center;
        }
        .footer .social-icon {
          margin-bottom: 15px;
        }
        .footer .social-icon a {
          margin: 0 12px;
          transition: transform 0.3s ease-in-out, filter 0.3s ease-in-out;
        }
        .footer .social-icon a:hover {
          transform: scale(1.1);
          filter: brightness(1.2);
        }
        .footer img {
          max-width: 120px; /* Adjust logo size */
        }
        .footer p {
          margin-top: 12px;
          font-size: 14px;
          opacity: 0.8;
        }
        @media (max-width: 768px) {
          .footer {
            text-align: center;
          }
          .footer .social-icon {
            justify-content: center;
            display: flex;
          }
          .footer .footer-logo {
            margin-bottom: 20px; /* ✅ Added margin below logo on small screens */
          }
        }
      `}</style>
      
      <footer className="footer">
        <Container>
          <Row className="align-items-center">
            <MailchimpForm />
            <Col xs={12} sm={6} className="text-center text-sm-start">
              <img src={logo} alt="Logo" className="footer-logo" />
            </Col>
            <Col xs={12} sm={6} className="text-center text-sm-end">
              <div className="social-icon">
                <a href="https://github.com/mohitarora786" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon4} alt="Github" />
                </a>
                <a href="https://www.linkedin.com/in/mohit-arora-018600229/" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon1} alt="Linkedin" />
                </a>
              </div>
              <p>Designed & Developed by Mohit Arora. Copyright © 2024. All Rights Reserved.</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};
